// Copyright (c) Move Closer 2022.
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

import { MagentoVersion } from '../../../../contexts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const CUSTOMER_FRAGMENT = gql`
fragment CustomerFragment on Customer {
    firstname
    lastname
    email
    date_of_birth
    is_subscribed
    addresses {
        id
        city
        company
        country_code
        default_billing
        default_shipping
        fax
        firstname
        id
        lastname
        middlename
        postcode
        prefix
        region {
            region
            region_code
            region_id
        }
        region_id
        street
        suffix
        telephone
        vat_id
    }
    orders(currentPage: 1, pageSize: 100) {
        items {
            items {
                id
                product_sku
                product_name
                product_type
                product_url_key
                quantity_ordered
                product_sale_price {
                    value
                    currency
                }
            }
            number
            updated_at
            status
            total {
                grand_total {
                    value
                    currency
                }
                shipping_handling {
                    amount_including_tax {
                        value
                        currency
                    }
                }
            }
        }
        total_count
    }
}
`

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const CUSTOMER_FRAGMENT_2_4 = gql`
fragment CustomerFragment on Customer {
    firstname
    lastname
    email
    date_of_birth
    is_subscribed
    friends_and_family
    addresses {
        id
        city
        company
        country_code
        default_billing
        default_shipping
        fax
        firstname
        id
        lastname
        middlename
        postcode
        prefix
        region {
            region
            region_code
            region_id
        }
        region_id
        street
        suffix
        telephone
        vat_id
    }
    orders(currentPage: 1, pageSize: 100) {
        items {
            items {
                id
                product_sku
                product_name
                product_type
                product_url_key
                quantity_ordered
                product_sale_price {
                    value
                    currency
                }
            }
            number
            status
            total {
                grand_total {
                    value
                    currency
                }
                shipping_handling {
                    amount_including_tax {
                        value
                        currency
                    }
                }
            }
        }
        total_count
    }
}
`

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const CUSTOMER_FRAGMENTS_MAP: Record<MagentoVersion, DocumentNode> = {
  [MagentoVersion.Default]: CUSTOMER_FRAGMENT,
  [MagentoVersion.Ver24]: CUSTOMER_FRAGMENT_2_4
}
